<template>
  <b-row class="card-body">
    <b-col cols="12" xl="10">
      <b-form-group :label=" 'attachments_with_description' | translate('global')">
        <b-form-file multiple :disabled="!actions.update"
                     :browse-text="'select_files' | translate('global')"
                     :placeholder="'no_selected_files' | translate('global')"
                     class="text-truncate"
                     v-model="files"/>
      </b-form-group>
    </b-col>
    <b-col cols="12" xl="2">
      <b-button variant="success" class="mt-xl-29 pull-right"
                :disabled="!files.length || spinners.isUploading || !actions.update"
                @click="onUploadFiles()">
        <b-spinner v-if="spinners.isUploading" type="grow" small/>
        {{ 'upload_files' | translate('global') }}
      </b-button>
    </b-col>
    <b-col cols="12">
      <div v-for="(status, fileName) in filesStatuses" :key="fileName">
        <p>
          <b-spinner v-if="filesStatuses[fileName] === 'loading'" variant="primary" type="grow" small/>
          <i v-if="filesStatuses[fileName] === 'loaded'" class="fa fa-check text-success"/>
          <i v-if="filesStatuses[fileName] !== 'loaded' && status !== 'loading'" class="fa fa-close text-danger"/>
          <span class="ml-3">{{ fileName }}</span>
          <span v-if="filesStatuses[fileName] !== 'loaded' && filesStatuses[fileName] !== 'loading'"
                class="ml-4 error-text">{{filesStatuses[fileName]}}
          </span>
        </p>
      </div>
      <hr>
    </b-col>
    <b-col cols="12">
      <AllDocumentsAttached :isDisabled="!actions['editAttachedDocumentStatus']"/>
    </b-col>
    <b-col cols="12" class="mt-3">
      <div v-if="spinners.tableIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <EmptyTable v-if="!tableItems.length"/>
        <b-table v-else class="table-sm text-center" responsive bordered :fields="tableFields" :items="tableItems">
          <template v-slot:options="row" class="flex-container">
            <AddComment :data="row.item" :isDisabled="!actions.update"/>
            <Download class="ml-2" :data="row.item"/>
            <Delete class="ml-2" :id="row.item.id" :isDisabled="!actions.delete"/>
          </template>
        </b-table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue';
import statuses from '@/store/statuses';
import VuexTypes from '@/store/types/index';
import Services from '@/services/index';
import forEach from 'lodash.foreach';
import { mapActions, mapGetters } from 'vuex';
import EmptyTable from '@/views/sharedComponents/EmptyTableData';
import AddComment from './AddComment.vue';
import Download from './DownloadAttachment.vue';
import Delete from './DeleteAttachment.vue';
import AllDocumentsAttached from './AllDocumentsAttached.vue';

const OrdersTypes = VuexTypes.orders;
const OrdersService = Services.orders;
export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      spinners: {
        tableIsLoading: true,
        isUploading: false,
      },
      actions: {},
      tableFields: [
        { key: 'file_name', label: this.$t('file_name', 'global') },
        { key: 'human_readable_size', label: this.$t('file_size', 'global') },
        { key: 'created_at', label: this.$t('created_at', 'global') },
        { key: 'comment', label: this.$t('comment', 'global') },
        { key: 'options', label: this.$t('options', 'global') }
      ],
      tableItems: [],
      files: [],
      filesStatuses: {},
      errorMsg: {}
    };
  },
  components: { EmptyTable, AddComment, Download, Delete, AllDocumentsAttached },
  computed: {
    ...mapGetters('Orders', [
      'orderUpdateData',
      'orderAddCommentToAttachment',
      'orderDeleteAttachment',
      'orderAttachments',
    ]),
  },
  watch: {
    orderAttachments: {
      handler: function () {
        if (this.orderAttachments.status === statuses.LOADED) {
          this.fillTableData();
          this.actions = this.orderAttachments.data.actions;
          this.spinners.tableIsLoading = false;
        }
      },
      deep: true
    },
    orderAddCommentToAttachment: {
      handler: function () {
        if (this.orderAddCommentToAttachment.status === statuses.LOADED) {
          this.getData();
          this.alertSuccess();
        } else if (this.orderAddCommentToAttachment.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
    orderDeleteAttachment: {
      handler: function () {
        if (this.orderDeleteAttachment.status === statuses.LOADED) {
          this.getData();
          this.alertSuccess();
        } else if (this.orderDeleteAttachment.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Orders', [
      OrdersTypes.ORDER_ATTACHMENTS,
    ]),
    getData() {
      this.ORDER_ATTACHMENTS(this.$route.params.id);
    },
    fillTableData() {
      const result = [];
      forEach(this.orderAttachments.data['order_attachments'], (item) => {
        result.push({
          id: item['id'],
          url: item['url'],
          mime_type: item['mime_type'],
          name: item['name'],
          file_name: item['file_name'],
          human_readable_size: item['human_readable_size'],
          created_at: item['created_at'],
          comment: item['custom_properties']['comment'] || null,
        });
      });
      this.tableItems = result;
    },
    onUploadFiles() {
      this.spinners.isUploading = true;
      const promises = [];

      forEach(this.files, (file) => {
        this.filesStatuses[file.name] = 'loading';
        const formData = new FormData();
        formData.append('file', file);

        const res = OrdersService.addAttachment(this.$route.params.id, formData);
        promises.push(res);

        res.then((status) => {
          Vue.set(this.filesStatuses, file.name, status.status);
        }).catch((errorStatus) => {
          Vue.set(this.filesStatuses, file.name, errorStatus.data.data.errors.file[0]);
        });
      });

      Promise.allSettled(promises).then(() => {
        this.spinners.isUploading = false;
        this.files = [];
        this.getData();
      });
    },
  }
};

</script>

<style scoped>
</style>
